module.exports = __webpack_public_path__ + "img/icon-prev-circle.7eab6b32.svg";